import { IconButton, Theme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import LogoutButtonIcon from '../../../../assets/icons/logoutIcon.svg?react';
import { ROUTES } from '../../../../constants/routes';
import { localStorageService } from '../../../../services/localStorageService/localStorageService';
import { sendEventToReactNative } from '../../../../common/utils/reactNativeHelpers';
import { WebViewEvents } from '../../../../common/enums/webViewEvents';

export const LogoutButton = ({
  iconColor = 'main',
}: {
  iconColor?: 'main' | '300';
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorageService().removeAccessToken();
    localStorageService().removeRefreshToken();
    localStorageService().removeUserId();
    localStorageService().removeHasShownBiometricDrawer();
    navigate(`/${ROUTES.LOGIN}`);

    sendEventToReactNative(WebViewEvents.LOGOUT, undefined);
  };
  return (
    <IconButton
      // color="common.white"
      aria-label="logout"
      size={'large'}
      onClick={handleLogout}
      sx={(theme: Theme) => ({
        padding: 0,
        svg: {
          path: {
            fill: theme.palette.gray[iconColor],
          },
        },
      })}
    >
      <LogoutButtonIcon />
    </IconButton>
  );
};
